/** Human message from an axios error; understands the backend's ProblemDetail ({ detail, errors }). */
export const getErrorMessage = (error, fallback = 'Something went wrong') => {
  const body = error?.response?.data
  if (body?.detail) return body.detail
  if (body?.message) return body.message
  if (error?.response?.status === 403) return "You don't have permission to do that"
  if (error?.code === 'ERR_NETWORK') return 'Cannot reach the server'
  return error?.message || fallback
}

/** The backend's list of validation errors, if any. */
export const getErrorList = (error) => error?.response?.data?.errors || []

/** Record validation errors ("fieldKey: message") → { fieldKey: message }. */
export const toFieldErrors = (error) => {
  const result = {}
  getErrorList(error).forEach((entry) => {
    const index = entry.indexOf(': ')
    if (index > 0) {
      const key = entry.slice(0, index)
      if (!result[key]) result[key] = entry.slice(index + 2)
    }
  })
  return result
}
